"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroAddress = void 0;
exports.zeroAddress = '0x0000000000000000000000000000000000000000';
//# sourceMappingURL=address.js.map